import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: 0,
  name: '',
  hid: '',
  photo: '',
  permissions: '',
  echibitDiver: 0,
  status: 0,
  email: '',
  is24h: false,
  expirations: {},
  orgs: [],
  admin: false
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setId: (state, action) => {
      state.id = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setHid: (state, action) => {
      state.hid = action.payload;
    },
    setPhoto: (state, action) => {
      state.photo = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions =  action.payload;
    },
    setExhibitDiver: (state, action) => {
      state.exhibitDiver =  action.payload;
    },
    setEmail: (state, action) => {
      state.email =  action.payload;
    },
    setIs24h: (state, action) => {
      state.is24h =  action.payload;
    },
    setExpirations: (state, action) => {
      state.expirations =  action.payload;
    },
    setOrgs: (state, action) => {
      state.orgs =  action.payload;
    },
    setStatus: (state, action) => {
      state.status =  action.payload;
    },
    setAdmin: (state, action) => {
      state.admin =  action.payload;
    },
    setUser: (state, action) => action.payload,
    clearUser: () => initialState
  },
})

// Action creators are generated for each case reducer function
export const { setId, setName, setHid, setPhoto, setPermissions, setExhibitDiver, setEmail, setIs24h, setExpirations, setOrgs, setStatus, setAdmin, setUser, clearUser } = userSlice.actions;

export default userSlice.reducer